/** アプリのアイコン(レールとホームのタイルで同じものを使う)。 */
import {
  AppstoreOutlined,
  ContactsOutlined,
  IdcardOutlined,
  LaptopOutlined,
  SafetyOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import type { ReactElement } from "react";

export function appIcon(key: string): ReactElement {
  switch (key) {
    case "hr":
      return <TeamOutlined />;
    case "mdm":
      return <LaptopOutlined />;
    case "idp":
      return <IdcardOutlined />;
    case "dlp":
      return <SafetyOutlined />;
    case "reception":
      return <ContactsOutlined />;
    default:
      return <AppstoreOutlined />;
  }
}
